import { render, staticRenderFns } from "./Indicadores.vue?vue&type=template&id=4eee562f&scoped=true&"
var script = {}
import style0 from "./Indicadores.vue?vue&type=style&index=0&id=4eee562f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eee562f",
  null
  
)

export default component.exports